import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/CertificateOfOrigin/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Certificate of Origin</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            In the global market, "where it's from" matters just as much as "what it is." The Certificate of
            Origin (CO) is the document that proves a product's economic nationality. For exporters and{' '}
            <Link href='https://www.df-alliance.com/blog/how-to-become-a-freight-forwarder-a-step-by-step-guide'>forwarders</Link>{' '}
            , this isn't just a formality, it's a money-saver. A properly issued CO is the only way
            to unlock the benefits of Free Trade Agreements (FTAs). It allows the importer to claim
            preferential duty rates, directly lowering the landed cost of the goods. Whether the destination
            has strict import quotas or preferential treaties, this document prevents the cargo from being
            held up or taxed at the maximum rate by customs authorities.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;